<template>
  <div>
    <workDynamicsS></workDynamicsS>
    <applicationCenterS></applicationCenterS>
    <noticeS></noticeS>
    <downloadS></downloadS>
  </div>
</template>

<script>
import workDynamicsS from "../workDynamicsS.vue";
import applicationCenterS from "../applicationCenterS.vue";
import noticeS from "../noticeS.vue";
import downloadS from "../downloadS.vue";
export default {
  components: { workDynamicsS, applicationCenterS, noticeS, downloadS }
};
</script>



// WEBPACK FOOTER //
// src/components/PageAll/portalPage.vue